import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTAddressToSDKAddress } from '@wix/sdk-runtime/transformations/address';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTImageToSDKImage } from '@wix/sdk-runtime/transformations/image';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { addLineItemsToDraftOrder as universalAddLineItemsToDraftOrder, commitDraftOrder as universalCommitDraftOrder, createCustomAdditionalFees as universalCreateCustomAdditionalFees, createCustomDiscounts as universalCreateCustomDiscounts, createDraftOrder as universalCreateDraftOrder, createEmptyDraftOrder as universalCreateEmptyDraftOrder, createOrderFromDraft as universalCreateOrderFromDraft, deleteCustomAdditionalFees as universalDeleteCustomAdditionalFees, deleteCustomDiscounts as universalDeleteCustomDiscounts, deleteDraftOrder as universalDeleteDraftOrder, getDraftOrder as universalGetDraftOrder, getOrderDraftabilityStatus as universalGetOrderDraftabilityStatus, queryDraftOrders as universalQueryDraftOrders, setAdditionalFees as universalSetAdditionalFees, setBillingInfo as universalSetBillingInfo, setBusinessLocation as universalSetBusinessLocation, setBuyerInfo as universalSetBuyerInfo, setDiscounts as universalSetDiscounts, setRecipientInfo as universalSetRecipientInfo, setShippingInfo as universalSetShippingInfo, setTaxExemption as universalSetTaxExemption, updateExtendedFields as universalUpdateExtendedFields, updateLineItems as universalUpdateLineItems, } from './ecom-v1-draft-order-draft-orders.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function createDraftOrder(httpClient) {
    return (orderId) => universalCreateDraftOrder(orderId, 
    // @ts-ignore
    { httpClient });
}
export function createEmptyDraftOrder(httpClient) {
    return () => universalCreateEmptyDraftOrder(
    // @ts-ignore
    { httpClient });
}
export function addLineItemsToDraftOrder(httpClient) {
    return (draftOrderId, options) => universalAddLineItemsToDraftOrder(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function updateLineItems(httpClient) {
    return (draftOrderId, lineItemChanges) => universalUpdateLineItems(draftOrderId, lineItemChanges, 
    // @ts-ignore
    { httpClient });
}
export function setDiscounts(httpClient) {
    return (draftOrderId, discounts) => universalSetDiscounts(draftOrderId, discounts, 
    // @ts-ignore
    { httpClient });
}
export function createCustomDiscounts(httpClient) {
    return (draftOrderId, options) => universalCreateCustomDiscounts(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function deleteCustomDiscounts(httpClient) {
    return (draftOrderId, discountIds) => universalDeleteCustomDiscounts(draftOrderId, discountIds, 
    // @ts-ignore
    { httpClient });
}
export function setAdditionalFees(httpClient) {
    return (draftOrderId, additionalFees) => universalSetAdditionalFees(draftOrderId, additionalFees, 
    // @ts-ignore
    { httpClient });
}
export function createCustomAdditionalFees(httpClient) {
    return (draftOrderId, options) => universalCreateCustomAdditionalFees(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function deleteCustomAdditionalFees(httpClient) {
    return (draftOrderId, customAdditionalFees) => universalDeleteCustomAdditionalFees(draftOrderId, customAdditionalFees, 
    // @ts-ignore
    { httpClient });
}
export function setShippingInfo(httpClient) {
    return (draftOrderId, options) => universalSetShippingInfo(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function setBuyerInfo(httpClient) {
    return (draftOrderId, options) => universalSetBuyerInfo(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function setRecipientInfo(httpClient) {
    return (draftOrderId, options) => universalSetRecipientInfo(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function setBillingInfo(httpClient) {
    return (draftOrderId, options) => universalSetBillingInfo(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function getDraftOrder(httpClient) {
    return (draftOrderId) => universalGetDraftOrder(draftOrderId, 
    // @ts-ignore
    { httpClient });
}
export function getOrderDraftabilityStatus(httpClient) {
    return (orderId) => universalGetOrderDraftabilityStatus(orderId, 
    // @ts-ignore
    { httpClient });
}
export function commitDraftOrder(httpClient) {
    return (draftOrderId, options) => universalCommitDraftOrder(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function createOrderFromDraft(httpClient) {
    return (draftOrderId, options) => universalCreateOrderFromDraft(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function deleteDraftOrder(httpClient) {
    return (draftOrderId) => universalDeleteDraftOrder(draftOrderId, 
    // @ts-ignore
    { httpClient });
}
export function queryDraftOrders(httpClient) {
    return () => universalQueryDraftOrders(
    // @ts-ignore
    { httpClient });
}
export function updateExtendedFields(httpClient) {
    return (_id, namespace, options) => universalUpdateExtendedFields(_id, namespace, options, 
    // @ts-ignore
    { httpClient });
}
export function setTaxExemption(httpClient) {
    return (draftOrderId, options) => universalSetTaxExemption(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export function setBusinessLocation(httpClient) {
    return (draftOrderId, options) => universalSetBusinessLocation(draftOrderId, options, 
    // @ts-ignore
    { httpClient });
}
export const onDraftOrderCreated = EventDefinition('wix.ecom.v1.draft_order_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.lineItems.lineItem.digitalFile.expirationDate' },
            {
                path: 'entity.lineItems.lineItem.subscriptionInfo.subscriptionSettings.startDate',
            },
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliverByDate',
            },
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliveryTimeSlot.from',
            },
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliveryTimeSlot.to',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.deliverByDate',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.deliveryTimeSlot.from',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.deliveryTimeSlot.to',
            },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTImageToSDKImage,
        paths: [{ path: 'entity.lineItems.lineItem.image' }],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [
            { path: 'entity.lineItems.lineItem.physicalProperties.weight' },
        ],
    },
    {
        transformFn: transformRESTAddressToSDKAddress,
        paths: [
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.shippingDestination.address',
            },
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.pickupDetails.address',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.shippingDestination.address',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.pickupDetails.address',
            },
            { path: 'entity.billingInfo.address' },
            {
                path: 'entity.recipientInfo.changedDetails.recipientInfoBeforeChange.address',
            },
            { path: 'entity.recipientInfo.recipientInfo.address' },
            {
                path: 'entity.billingDetails.changedDetails.billingInfoBeforeChange.address',
            },
            { path: 'entity.billingDetails.billingInfo.address' },
        ],
    },
])))();
export const onDraftOrderDeleted = EventDefinition('wix.ecom.v1.draft_order_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'undefined.createdDate' },
            { path: 'undefined.updatedDate' },
            { path: 'undefined.lineItems.lineItem.digitalFile.expirationDate' },
            {
                path: 'undefined.lineItems.lineItem.subscriptionInfo.subscriptionSettings.startDate',
            },
            {
                path: 'undefined.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliverByDate',
            },
            {
                path: 'undefined.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliveryTimeSlot.from',
            },
            {
                path: 'undefined.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliveryTimeSlot.to',
            },
            {
                path: 'undefined.shippingInfo.shippingInfo.logistics.deliverByDate',
            },
            {
                path: 'undefined.shippingInfo.shippingInfo.logistics.deliveryTimeSlot.from',
            },
            {
                path: 'undefined.shippingInfo.shippingInfo.logistics.deliveryTimeSlot.to',
            },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTImageToSDKImage,
        paths: [{ path: 'undefined.lineItems.lineItem.image' }],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [
            { path: 'undefined.lineItems.lineItem.physicalProperties.weight' },
        ],
    },
    {
        transformFn: transformRESTAddressToSDKAddress,
        paths: [
            {
                path: 'undefined.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.shippingDestination.address',
            },
            {
                path: 'undefined.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.pickupDetails.address',
            },
            {
                path: 'undefined.shippingInfo.shippingInfo.logistics.shippingDestination.address',
            },
            {
                path: 'undefined.shippingInfo.shippingInfo.logistics.pickupDetails.address',
            },
            { path: 'undefined.billingInfo.address' },
            {
                path: 'undefined.recipientInfo.changedDetails.recipientInfoBeforeChange.address',
            },
            { path: 'undefined.recipientInfo.recipientInfo.address' },
            {
                path: 'undefined.billingDetails.changedDetails.billingInfoBeforeChange.address',
            },
            { path: 'undefined.billingDetails.billingInfo.address' },
        ],
    },
])))();
export const onDraftOrderUpdated = EventDefinition('wix.ecom.v1.draft_order_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.lineItems.lineItem.digitalFile.expirationDate' },
            {
                path: 'entity.lineItems.lineItem.subscriptionInfo.subscriptionSettings.startDate',
            },
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliverByDate',
            },
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliveryTimeSlot.from',
            },
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.deliveryTimeSlot.to',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.deliverByDate',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.deliveryTimeSlot.from',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.deliveryTimeSlot.to',
            },
            { path: 'metadata.eventTime' },
        ],
    },
    {
        transformFn: transformRESTImageToSDKImage,
        paths: [{ path: 'entity.lineItems.lineItem.image' }],
    },
    {
        transformFn: transformRESTFloatToSDKFloat,
        paths: [
            { path: 'entity.lineItems.lineItem.physicalProperties.weight' },
        ],
    },
    {
        transformFn: transformRESTAddressToSDKAddress,
        paths: [
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.shippingDestination.address',
            },
            {
                path: 'entity.shippingInfo.changedDetails.shippingInfoBeforeChange.logistics.pickupDetails.address',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.shippingDestination.address',
            },
            {
                path: 'entity.shippingInfo.shippingInfo.logistics.pickupDetails.address',
            },
            { path: 'entity.billingInfo.address' },
            {
                path: 'entity.recipientInfo.changedDetails.recipientInfoBeforeChange.address',
            },
            { path: 'entity.recipientInfo.recipientInfo.address' },
            {
                path: 'entity.billingDetails.changedDetails.billingInfoBeforeChange.address',
            },
            { path: 'entity.billingDetails.billingInfo.address' },
        ],
    },
])))();
export { ActivityType, AdjustmentType, AppliedDiscountDiscountType, AttributionSource, ChannelType, DescriptionLineType, DiscountReason, DiscountType, EditingStatus, FileType, FulfillmentStatus, ItemTypeItemType, JurisdictionType, LineItemQuantityChangeType, NonDraftableReason, OrderStatus, PaymentOptionType, PaymentStatus, PickupDetailsPickupMethod, PickupMethod, RuleType, SortOrder, SourceType, SubscriptionFrequency, TaxableAddressType, VatType, WebhookIdentityType, WeightUnit, } from './ecom-v1-draft-order-draft-orders.universal.js';
//# sourceMappingURL=ecom-v1-draft-order-draft-orders.public.js.map